import { render, staticRenderFns } from "./AddEditProduct.vue?vue&type=template&id=0ebbe143&scoped=true&"
import script from "./AddEditProduct.vue?vue&type=script&lang=js&"
export * from "./AddEditProduct.vue?vue&type=script&lang=js&"
import style0 from "./AddEditProduct.vue?vue&type=style&index=0&id=0ebbe143&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebbe143",
  null
  
)

export default component.exports